import React from "react";
import { AppProvider } from './context/AppContext';
import Router from "./router";
import MovedScreen from "./MovedScreen";

// The site moved to app.mashlimimplus.co.il/app — every visitor sees the "we moved" screen.
// Set to false to bring the old app back.
const SHOW_MOVED_SCREEN = true;

const App = () => {
  if (SHOW_MOVED_SCREEN) return <MovedScreen />;

  return (
    <AppProvider>
      <Router />
    </AppProvider>
  );
};

export default App;
